import { useSessionStorageState } from 'ahooks';
import Button from 'components/atoms/Button';
import BottomSheet from 'components/molecules/BottomSheet';
import { BUTTON_NAMES } from 'constant/button-names';
import { useGlobalConfig } from 'pages/queries/global.queries';
import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

// keeping it in case need to reuse
const StyledNote = styled.p<{ marginBottom?: string }>`
  color: ${({ theme }) => theme.components.eidNoticeBottomSheet.note.color};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

const StyledList = styled.ul`
  font-size: 12px;
  padding-left: 20px;
  font-weight: 300;
`;

const StyledHeading = styled.h5`
  padding-left: 4px;
  font-size: 12px;
`;

export default function EidNoticeBottomSheet(): JSX.Element {
  const { data: appConfig } = useGlobalConfig();
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const { t } = useTranslation();
  const [presented, setPresented] = useSessionStorageState('eidNotice-presented', {
    defaultValue: false,
  });

  const handleClose = useCallback(() => {
    setPresented(true);
  }, [setPresented]);
  useEffect(() => {
    if (!appConfig) return;

    if (appConfig?.isShowEidBannerPWA?.toString()?.toLowerCase() === 'false') {
      setPresented(true);
    }
    setIsFetching(false);
  }, [appConfig]);

  if (isFetching || presented) {
    return <> </>;
  }
  return (
    <BottomSheet title={t('announcements.eidNotice.title')} show={!presented} onClose={handleClose}>
      <StyledHeading>{t('announcements.eidNotice.description')}</StyledHeading>
      <StyledList>
        <li>
          <Trans
            t={t}
            i18nKey="announcements.eidNotice.first_term"
            components={{
              bold: <span className="h5" />,
            }}
          />
        </li>
        <li>
          <Trans
            t={t}
            i18nKey="announcements.eidNotice.second_term"
            components={{
              bold: <span className="h5" />,
            }}
          />
        </li>
      </StyledList>
      {/* keeping it in case need to reuse */}
      {/* <StyledNote marginBottom={'15px'}>{t('announcements.eidNotice.notice')}</StyledNote> */}
      <StyledNote>{t('announcements.eidNotice.eidMubarak')}</StyledNote>
      <Button buttonName={BUTTON_NAMES.GOT_IT} onClick={handleClose}>
        {t('common.gotIt')}
      </Button>
    </BottomSheet>
  );
}
